import React, { useState } from 'react';

import CapInput from '../../CapInput';
import CapIcon from '../../CapIcon';

import { clsPrefix } from './constants';
import classnames from 'classnames';

export const MetaBlock = ({
  requestId,
  actions,
  updateLikeResultApi,
  updateDislikeResultApi,
  textWarn,
  textThank,
  textAddCommentPlaceholder,
}) => {
  const [like, setLike] = useState(0);
  const [hint, setHint] = useState(textWarn);
  const [comment, setComment] = useState('');
  const [responded, setResponded] = useState(false);
  const likeResp = async () => {
    setLike(1);
    actions.updateLikeResult({ requestId, updateLikeResultApi });
    setHint(textThank);
  };

  const dislikeResp = async () => {
    setLike(-1);
    setHint(textWarn);
  };

  return (
    <div className={`${clsPrefix}-meta-data`}>
      <div className={`${clsPrefix}-feedback`}>
        <div
          style={{
            whiteSpace: 'nowrap',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <span style={{ fontSize: '0.9rem', color: '#5E6C84' }}>{hint}</span>
          <span
            className={classnames(
              `${clsPrefix}-rate-answer`,
              `${clsPrefix}-like`,
            )}
            data-selected={like === 1}
            onClick={likeResp}
          >
            👍
          </span>
          <span
            className={classnames(
              `${clsPrefix}-rate-answer`,
              `${clsPrefix}-dislike`,
            )}
            data-selected={like === -1}
            onClick={dislikeResp}
          >
            👎
          </span>
        </div>
        {like === -1 &&
          !responded && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginTop: '0.5rem',
                gap: '0.5rem',
              }}
            >
              <div style={{ flexGrow: '1' }}>
                <CapInput.TextArea
                  data-testid="comment-text-area"
                  autosize={{ minRows: 2, maxRows: 5 }}
                  placeholder={textAddCommentPlaceholder}
                  onChange={e => {
                    setComment(e.target.value);
                  }}
                >
                  {comment}
                </CapInput.TextArea>
              </div>
              <CapIcon
                type="send-filled"
                className={`${clsPrefix}-send-img`}
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  actions.updateDislikeResult({
                    requestId,
                    updateDislikeResultApi,
                    feedback: comment,
                  });
                  setResponded(true);
                  setHint(textThank);
                }}
              />
            </div>
          )}
      </div>
    </div>
  );
};
